import { Link } from 'react-router-dom';
import { getHotComics } from '@/mocks/comics';

export default function FeaturedComics() {
  const hotComics = getHotComics(6);

  return (
    <section className="py-14 md:py-20 bg-background-100" aria-labelledby="featured-title">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2
              id="featured-title"
              className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2"
            >
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600">人气最高的韩漫作品，不容错过</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line" style={{ width: '14px', height: '14px' }}></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop="">
          {hotComics.map((comic) => (
            <Link
              key={comic.slug}
              to={`/comic/${comic.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 韩漫在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-primary-500 text-white text-xs rounded-full font-label">
                    <i className="ri-star-fill text-[10px]" style={{ width: '10px', height: '10px' }}></i>
                    {comic.rating}
                  </span>
                </div>
                {comic.status === '已完结' && (
                  <div className="absolute top-2 right-2">
                    <span className="inline-flex px-2 py-0.5 bg-accent-500 text-white text-xs rounded-full font-label">
                      完结
                    </span>
                  </div>
                )}
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading text-sm md:text-base text-foreground-900 group-hover:text-primary-500 transition-colors truncate mb-1.5">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 truncate">{comic.author}</p>
                <div className="flex items-center gap-3 mt-2 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" style={{ width: '12px', height: '12px' }}></i>
                    {(comic.views / 10000).toFixed(1)}万
                  </span>
                  <span>{comic.status}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部漫画
            <i className="ri-arrow-right-line" style={{ width: '14px', height: '14px' }}></i>
          </Link>
        </div>
      </div>
    </section>
  );
}